const ArrowLeftPagination = ({ size = 24, fill = '#FFFEFE', viewBox = '0 0 7 12' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.33325 0.128116L6.33325 11.8716L0.461518 5.99985L6.33325 0.128116Z" fill={fill} />
    </svg>
  );
};

export default ArrowLeftPagination;
